import { embedAdSlots } from '@/app_lib/htmlParser/inserter/rules/dotCom/embedAdSlots';
import { embedNativoTout } from '@/app_lib/htmlParser/inserter/rules/dotCom/embedNativoTout';
import { embedPianoTemplate } from '@/app_lib/htmlParser/inserter/rules/dotCom/embedPianoTemplate';
import { embedRelatedVideoRule } from '@/app_lib/htmlParser/inserter/rules/dotCom/embedRelatedVideoRule';
import { embedSubscriptionPleaRule } from '@/app_lib/htmlParser/inserter/rules/dotCom/embedSubscriptionPleaRule';
import { embedRatesWidgetsClient } from '@/app_lib/htmlParser/inserter/rules/dotCom/widgets/embedRatesWidgetsClient';
import { embedEducationWidgetsRule } from '@/app_lib/htmlParser/inserter/rules/education/embedEducationWidgets';
import type { ClientParserData } from '@/app_lib/htmlParser/inserter/rules/types';

const funcMapper = {
  embedAdSlots: (args: Parameters<typeof embedAdSlots>) => embedAdSlots(...args),
  embedEducationWidgetsRule: (args: Parameters<typeof embedEducationWidgetsRule>) => embedEducationWidgetsRule(...args),
  embedNativoTout: (args: Parameters<typeof embedNativoTout>) => embedNativoTout(...args),
  embedPianoTemplate: (args: Parameters<typeof embedPianoTemplate>) => embedPianoTemplate(...args),
  embedRatesWidgetsClient: (args: Parameters<typeof embedRatesWidgetsClient>) => embedRatesWidgetsClient(...args),
  embedRelatedVideoRule: (args: Parameters<typeof embedRelatedVideoRule>) => embedRelatedVideoRule(...args),
  embedSubscriptionPleaRule: (args: Parameters<typeof embedSubscriptionPleaRule>) => embedSubscriptionPleaRule(...args),
  // Add more mappings as needed
};

export function clientRuleBuilder(data: ClientParserData[]) {
  if (!data || data.length === 0) {
    return [];
  }

  return data.map((item) => {
    return funcMapper[item.func]([item.args]);
  });
}
